import clientParams, { bookingsPageValidations } from "./common_variable";
import * as Yup from "yup";
// import { staffList } from "@/apis/staff/staffApi";
// import { staffList } from "./staff_list";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import API_ENDPOINTS from "./api";
import api from "@/services/axios_custom";
import dayjs from "dayjs";
import { Entity_types, Security_Types } from "./permission_bits";
import { usePermissionMask } from "./usePermissionMask";
import _ from "lodash";

var refLists = [];
var staffList = [];
var judgeLists = [];
var user = null;
const SetReflist = () => {
  const refList = useSelector((state) => state?.refListReducer?.refLists);
  const stafflist = useSelector((state) => state?.staff?.activeList);
  const judgelist = useSelector((state) => state?.staff?.judgeList);
  useEffect(() => {
    const loginUser = JSON.parse(localStorage.getItem("userDetails"));
    if (isNonEmptyVariable(loginUser)) {
      user = loginUser;
    }
  }, []);

  useEffect(() => {
    refLists = refList;
  }, [refList]);
  useEffect(() => {
    staffList = stafflist;
  }, [stafflist]);
  useEffect(() => {
    judgeLists = judgelist;
  }, [judgelist]);
};

var clientParamsLocal = [];
const SetClientParam = () => {
  const globalClientParam = useSelector((state) => state?.clientParams?.list);

  useEffect(() => {
    if (isNonEmptyVariable(globalClientParam)) {
      clientParamsLocal = [...clientParams, ...globalClientParam];
    }
  }, [globalClientParam]);
};

var securityRules = null;
const SetSecurityRules = () => {
  const { parsePermissionMask } = usePermissionMask();
  const { userDetail } = useSelector((state) => state?.userDetail);

  useEffect(() => {
    if (isNonEmptyVariable(userDetail)) {
      const securityRulesList = _.cloneDeep(userDetail);

      if (isNonEmptyVariable(securityRulesList)) {
        let preSecurityRules = securityRulesList?.staffGroup;

        preSecurityRules = {
          securityRulesCriteria: preSecurityRules?.securityRulesCriteria?.map(
            (src) => {
              const allowSetting =
                isNonEmptyVariable(src?.allowSetting) &&
                !isNaN(src?.allowSetting)
                  ? parseInt(src?.allowSetting)
                  : 0;
              const denySetting =
                isNonEmptyVariable(src?.denySetting) && !isNaN(src?.denySetting)
                  ? parseInt(src?.denySetting)
                  : 0;
              return {
                ...src,
                allowSetting: parsePermissionMask(allowSetting),
                denySetting: parsePermissionMask(denySetting),
              };
            }
          ),
          securityRulesFunctionality:
            preSecurityRules?.securityRulesFunctionality?.map((src) => {
              const allowSetting =
                isNonEmptyVariable(src?.allowSetting) &&
                !isNaN(src?.allowSetting)
                  ? parseInt(src?.allowSetting)
                  : 0;
              const denySetting =
                isNonEmptyVariable(src?.denySetting) && !isNaN(src?.denySetting)
                  ? parseInt(src?.denySetting)
                  : 0;
              return {
                ...src,
                allowSetting: parsePermissionMask(allowSetting),
                denySetting: parsePermissionMask(denySetting),
              };
            }),
          securityRulesRecords: preSecurityRules?.securityRulesRecords?.map(
            (src) => {
              const allowSetting =
                isNonEmptyVariable(src?.allowSetting) &&
                !isNaN(src?.allowSetting)
                  ? parseInt(src?.allowSetting)
                  : 0;
              const denySetting =
                isNonEmptyVariable(src?.denySetting) && !isNaN(src?.denySetting)
                  ? parseInt(src?.denySetting)
                  : 0;

              return {
                ...src,
                allowSetting: parsePermissionMask(allowSetting),
                denySetting: parsePermissionMask(denySetting),
              };
            }
          ),
        };

        securityRules = preSecurityRules;
      }
    }
  }, [userDetail]);
};

var modulesList = null;
var submoduleList = null;
var reportList = null;
var tableViewsList = null;
const SetModulesList = () => {
  const { configModules, configSubModules, reports, tablesViewsNew } = useSelector(
    (state) => state?.config
  );
  useEffect(() => {
    if (isNonEmptyVariable(configModules)) {
      modulesList = configModules;
    }

    if (isNonEmptyVariable(configSubModules)) {
      submoduleList = configSubModules;
    }

    if(isNonEmptyVariable(reports)) {
      reportList = reports;
    }

    if(isNonEmptyVariable(reports)) {
      tableViewsList = tablesViewsNew;
    }
  }, [configModules, configSubModules, reports, tablesViewsNew]);
};

/**
 * Checks if the object is empty.
 * @param {Object} obj - The object to check.
 * @returns {boolean} - Returns true if the object is empty, false otherwise.
 */
const isEmptyObject = (obj) => {
  if (obj === null || typeof obj === "undefined") return true;
  if (Object.keys(obj)?.length === 0) {
    return true;
  }
  const everyScan = Object.keys(obj).every((o) => {
    return !isNonEmptyVariable(obj[o]);
  });

  return everyScan;
};

/**
 * Converts an object to an array of key-value pairs with custom labels.
 * @param {Object} obj - The object to convert.
 * @param {String} keyLabel - The label for the key in the resulting objects.
 * @param {String} valueLabel - The label for the value in the resulting objects.
 * @returns {Array} - An array of objects with custom key-value labels.
 */
const objectToArray = (obj, keyLabel = "key", valueLabel = "value") => {
  if (Object.keys(obj).length === 0) {
    return [];
  }

  return Object.keys(obj)
    .filter((key) => isNonEmptyVariable(obj[key])) // Filter out keys with empty values
    .map((key) => ({
      [keyLabel]: key,
      [valueLabel]: obj[key],
    }));
};

/**
 * Converts an object to a query string, supporting nested objects.
 *
 * @param {Object} obj - The object to convert to query parameters.
 * @param {String} [prefix] - Optional prefix for nested keys.
 * @returns {String} - The resulting query string.
 */
const toQueryString = (obj, prefix) => {
  const queryString = Object.keys(obj).map((key) => {
    const value = obj[key];
    const prefixedKey = prefix ? `${prefix}[${key}]` : key;

    if (typeof value === "object" && value !== null) {
      return toQueryString(value, prefixedKey);
    } else {
      return `${encodeURIComponent(prefixedKey)}=${encodeURIComponent(value)}`;
    }
  });

  return queryString.join("&");
};

/**
 * Checks if a variable is non-empty.
 *
 * A variable is considered non-empty if it is not undefined, null, or an empty string.
 *
 * @param {*} value - The variable to check.
 * @returns {boolean} - Returns true if the variable is non-empty; otherwise, false.
 */
const isNonEmptyVariable = (value) => {
  return (
    typeof value !== "undefined" &&
    value !== null &&
    value !== "" &&
    value !== "undefined"
  );
};

/**
 * Creates a debounced version of a function that delays its execution
 * until after a specified wait time has passed since it was last called.
 *
 * @param {Function} func - The function to debounce.
 * @param {number} wait - The delay in milliseconds to wait before invoking the function.
 * @returns {Function} - A debounced function that delays calling `func` until after `wait` milliseconds.
 */
const debounce = (func, wait) => {
  let timeout;

  return function (...args) {
    const context = this;

    clearTimeout(timeout);

    timeout = setTimeout(() => {
      func.apply(context, args);
    }, wait);
  };
};

/**
 * Generates an array of numbers from 1 to the given number.
 *
 * @param {number|string} number - The number up to which the array should be generated.
 *                                 Can be a number or a string representation of a number.
 * @returns {number[]} - An array containing numbers from 1 to the given number.
 */
const generateArray = (number) => {
  // Ensure the input is a number by parsing it into an integer.
  number = parseInt(number);

  // Create an array of the specified length (number),
  // then use Array.from to fill it with numbers from 1 to `number`.
  return Array.from({ length: number }, (_, i) => i + 1);
};

/**
 * To diplay component if it has permission
 *
 * @param {string} paramContext - This arguments is used to check with condition if it is there or not
 * @returns {Boolean} - It will returns boolean value
 */
const checkField = (paramContext) => {
  return clientParamsLocal?.find(
    (cp) => cp?.paramContext === paramContext && cp?.paramName === "Display"
  )?.paramValue;
};

/**
 * Generates a validation schema by using Yup validator
 *
 * @param {string} paramContext - This arguments is used to build validator
 * @returns {Object} - An object will return with entire schema that contains all matched conditions
 */
const checkFieldValidation = (
  paramContext,
  paramType = "text",
  label = "",
  clientList = null
) => {
  return new Promise((resolve, reject) => {
    let schema = Yup;

    switch (paramType) {
      case "text":
        schema = schema.string();
        break;
      case "number":
        schema = schema.number();
        break;
      default:
        schema = schema.string();
        break;
    }

    const clientParamValidation = Object.values(clientList)
      .map((item) => item.paramContext)
      .filter(
        (context) => context.toLowerCase() === paramContext?.toLowerCase()
      );

    // const clientParamValidation = clientList?.filter(
    //     (cp) => cp?.paramContext?.toLowerCase() === paramContext?.toLowerCase()
    // );

    if (!clientParamValidation || clientParamValidation.length === 0) {
      // If no validations are found, resolve schema as optional
      return resolve(schema.optional());
    }

    let isValid = true;
    clientList?.forEach((cpv, index) => {
      if (cpv?.paramName?.toLowerCase() === "required" && cpv?.paramValue) {
        schema = schema.required(`${label || "This field"} is required`); // Add required validation
        isValid = false;
      }

      if (cpv?.paramName?.toLowerCase() === "regularexpression") {
        if (cpv?.paramValue?.includes("||")) {
          const [pattern, message] = cpv?.paramValue?.split("||") || ["", ""];
          schema = schema.matches(
            new RegExp(pattern),
            message || "Invalid format"
          ); // Add regex validation
          isValid = false;
        }
      }

      if (index === clientList?.length - 1) {
        if (isValid) {
          schema = schema.optional();
        }

        resolve(schema);
      }
    });
  });
};

/**
 * Retrieves a list of options from the reference list based on the provided key.
 * - Includes a default "Select" option at the beginning of the list.
 * - Sorts the retrieved items in descending order by `Sequence_Number`.
 * - Handles cases where the reference list or its items are undefined gracefully.
 *
 * @param {string} key - The name of the reference list to search for.
 * @returns {Array<Object>} - An array of objects representing the options,
 *                            with a default "Select" option included at the start.
 *
 */
const getOptionsFromRefList = (
  key,
  isStaff = false,
  longStringRequired = false,
  isID = false,
  refListGlobalID = "",
  refListID = ""
) => {
  if (isStaff) {
    return staffList
      ?.map((sl) => ({
        value: sl?.staffId,
        label: longStringRequired ? sl?.staffDescriptionCached : sl?.userName,
      }))
      .filter((item) => item.value != null && item.label != null)
      .sort((a, b) => {
        const isAlphaA = /^[A-Za-z]/.test(a.label);
        const isAlphaB = /^[A-Za-z]/.test(b.label);

        // If one starts with a letter and the other doesn't, prioritize the letter one
        if (isAlphaA && !isAlphaB) return -1;
        if (!isAlphaA && isAlphaB) return 1;

        // If both are same type (both alpha or both non-alpha), sort alphabetically
        return a.label.localeCompare(b.label, undefined, {
          sensitivity: "base",
        });
      });
  }
  if (key === "Judge List") {
    return judgeLists
      ?.map((sl) => ({
        value: sl?.addressBookId,
        label: sl?.lastName,
      }))
      .filter((item) => item.value != null && item.label != null);
  }
  let refList = [];

  if (refListGlobalID !== "") {
    refList = refLists?.find((rl) => rl?.refListGlobalID == refListGlobalID);
  } else if (refListID !== "") {
    refList = refLists?.find((rl) => rl?.refListId === Number(refListID));
  } else {
    refList = refLists?.find(
      (rl) => rl?.refListName?.toLowerCase() === key?.toLowerCase()
    );
  }
  // Extract and sort items, adding the default item at the start
  let sortedItems = refList?.refListItems?.filter((rli) => rli?.enabled) || [];

  const isLongString = refList?.displayFieldName === "Long_String" || !!longStringRequired;

  // Add first Empty value for all select fields
  if (sortedItems?.length) {
    sortedItems.unshift({
      refListItemGlobalId: "",
      defaultString: "",
      longString: "",
    });
  }

  // ?.sort((a, b) => b?.sequenceNumber - a?.sequenceNumber) || [];
  return sortedItems?.map((aa) => {
    return {
      value: isID ? aa?.refListItemGlobalId : aa?.defaultString,
      enabled: aa?.enabled,
      label:
        isLongString && isNonEmptyVariable(aa?.longString)
          ? aa?.longString
          : aa?.defaultString,
    };
  });
};

const getRefListNameByID = (
  key,
  id,
  isStaff = false,
  longStringRequired = false
) => {
  if (isNaN(id)) {
    return "";
  }
  let retStr = "";

  if (isStaff) {
    const staff = staffList?.find((sl) => sl?.staffId === id);
    if (isNonEmptyVariable(staff)) {
      return staff?.userName;
    } else {
      return "";
    }
  }

  const refList = refLists?.find(
    (rl) => rl?.refListName?.toLowerCase() === key?.toLowerCase()
  );

  const refListItem = refList?.refListItems?.find(
    (rli) => rli?.refListItemGlobalId === id
  );

  if (isNonEmptyVariable(refListItem)) {
    if (longStringRequired) {
      retStr = refListItem?.longString;
    } else {
      retStr = refListItem?.defaultString;
    }
  }

  return retStr;
};

/**
 * Maps SQL data types to their corresponding HTML input types for form rendering.
 *
 * - Supports a variety of SQL data types, including character, numeric, date/time, and boolean types.
 * - Decides the most appropriate HTML input type based on SQL type characteristics.
 * - Provides a fallback to "text" for unsupported or unknown SQL types.
 *
 * @param {string} sqlType - The SQL data type to be mapped (e.g., "varchar(255)", "int", "datetime").
 * @returns {string} - The corresponding HTML input type (e.g., "text", "number", "date", "textarea").
 *
 * Example:
 * Input: sqlType = "varchar(255)"
 * Output: "text"
 *
 * Input: sqlType = "datetime"
 * Output: "datetime-local"
 *
 * Notes:
 * - Character types ("char", "varchar") are mapped to "text" or "textarea" based on their size.
 * - Integer and floating-point types are mapped to "number".
 * - Boolean types ("bit") are mapped to "select" (can be customized for "checkbox").
 * - Date/time types are mapped to respective HTML5 input types ("date", "datetime-local").
 */
const getSQLTypeToHTMLType = (sqlType) => {
  let type = ""; // Default to empty

  // Handle character types
  if (sqlType?.toLowerCase()?.includes("char")) {
    // Extract size within parentheses, e.g., varchar(255)
    const sizeMatch = sqlType?.match(/\((\d+)\)/); // Regular expression to extract size
    const size = sizeMatch ? parseInt(sizeMatch[1]) : null;

    // Decide between text or textarea
    type = size && size > 255 ? "textarea" : "text";
  }
  // Handle integer types
  else if (sqlType?.toLowerCase()?.includes("int")) {
    type = "number";
  }
  // Handle boolean types
  else if (sqlType?.toLowerCase()?.includes("bit")) {
    type = "select"; // Changed to checkbox for boolean values
  }
  // Handle datetime types
  else if (sqlType?.toLowerCase()?.includes("datetime")) {
    type = "datetime"; // HTML5 datetime input
  }
  // Handle datetime types
  else if (sqlType?.toLowerCase()?.includes("date")) {
    type = "date"; // HTML5 datetime input
  }
  // Handle date types
  else if (sqlType?.toLowerCase()?.includes("date")) {
    type = "date";
  }

  // Handle floating point or decimal numbers
  else if (
    sqlType?.toLowerCase()?.includes("float") ||
    sqlType?.toLowerCase()?.includes("decimal")
  ) {
    type = "number"; // Number type can handle decimals
  }
  // Handle large text fields
  else if (sqlType?.toLowerCase()?.includes("text")) {
    type = "textarea";
  }

  // Handle large text fields
  else if (sqlType?.toLowerCase()?.includes("checkbox")) {
    type = "checkbox";
  }

  // Fallback to text if no match
  else {
    type = "text";
  }

  return type;
};

const arrayToObject = async (fieldArray, clientValues) => {
  try {
    // Validate each field asynchronously and collect results
    const validationResults = await Promise.allSettled(
      fieldArray?.map(async (field) => {
        const validationRule = await checkFieldValidation(
          `${field?.tableName?.toLowerCase()}:${field?.columnName?.toLowerCase()}`,
          field?.type?.toLowerCase(),
          field?.label,
          clientValues
        );
        return { [field?.columnName]: validationRule };
      })
    );

    // Aggregate results into a single object
    const resultObject = validationResults.reduce((acc, result) => {
      if (result.status === "fulfilled") {
        // Merge the fulfilled result into the accumulated object
        return { ...acc, ...result.value };
      }

      // Optional: Log or handle rejected promises
      console.error(`Validation failed for a field: ${result.reason}`);
      return acc;
    }, {});

    return resultObject; // Return the aggregated result object
  } catch (error) {
    console.error(`Error processing field validations: ${error.message}`);
    throw new Error(error.message);
  }
};

/**
 * To diplay component if it has permission
 *
 * @param {string} paramContext - This arguments is used to check with condition if it is there or not
 * @returns {Boolean} - It will returns boolean value
 */
const checkRequiredField = (paramContext) => {
  const result = clientParamsLocal?.find(
    (cp) =>
      cp?.paramContext?.toLowerCase() === paramContext.toLowerCase() &&
      cp?.paramName.toLowerCase() === "required"
  )?.paramValue;

  return result;
};

/**
 * Calculates the age based on the given date of birth.
 *
 * @param {string|Date} dob - The date of birth. It can be a string or a Date object.
 * @returns {number} The calculated age.
 */
const findAgefromDOB = (dob) => {
  const dobDate = new Date(dob);
  const today = new Date();

  let age = today.getFullYear() - dobDate.getFullYear();
  const monthDiff = today.getMonth() - dobDate.getMonth();
  const dayDiff = today.getDate() - dobDate.getDate();

  // Adjust age if the birthday has not occurred yet this year
  if (monthDiff < 0 || (monthDiff === 0 && dayDiff < 0)) {
    age--;
  }

  return age;
};

/**
 * Generates validation rules for a form field based on the provided parameter context.
 *
 * - Checks the `clientParams` array for matching parameter contexts.
 * - Adds validation rules for required fields and regular expressions.
 * - Supports custom error messages for both required and regex validations.
 *
 * @param {string} paramContext - The context parameter to check for validation rules.
 * @param {string} label - The label of the field, used in validation messages.
 * @returns {Array<Object>} - An array of validation rule objects.
 *
 * Example:
 * Input: paramContext = "username", label = "Username"
 * Output: [
 *   { required: true, message: "Username is required" },
 *   { pattern: /^regex$/, message: "Invalid format" }
 * ]
 */
const generateRules = (paramContext, label, setRequired = true) => {
  const location = useLocation()?.pathname;
  let validations = [...clientParamsLocal];
  if (location === "/bookings") {
    validations = [...bookingsPageValidations, ...clientParamsLocal];
  }

  const rules = [];
  validations?.forEach((cp) => {
    if (cp?.paramContext?.toLowerCase() === paramContext.toLowerCase()) {
      if (cp?.paramName == "required" && cp?.paramValue && setRequired) {
        rules.push({
          required: true,
          message: `${label} is required`,
        });
      } else if (cp?.paramName?.toLowerCase() === "regularexpression") {
        const [pattern, message] = cp?.paramValue?.split("||") || ["", ""];
        rules.push({
          pattern: new RegExp(`^${pattern}$`),
          message: message || "Invalid format",
        });
      }

      if (cp?.required) {
        rules.push({
          required: true,
          message: `${label} is required`,
        });
      }
    }
  });

  return rules;
};

const filteredUndefinedData = (data) => {
  const filteredData = Object.fromEntries(
    Object.entries(data).filter(([_, value]) => value !== undefined)
  );

  return filteredData;
};

const getRefListItemsbyName = (key) => {
  const refList = refLists?.find(
    (rl) => rl?.refListName?.toLowerCase() === key?.toLowerCase()
  );

  // Extract and sort items, adding the default item at the start
  return refList?.refListItems?.filter((rli) => rli?.enabled) || [];
};

const getFullAddress = (address) => {
  if (!isNonEmptyVariable(getFullAddress)) {
    return "";
  }
  let retStr = "";

  if (isNonEmptyVariable(address?.addressStreetNumber)) {
    retStr += address?.addressStreetNumber + " ";
  }

  if (isNonEmptyVariable(address?.addressStreet1)) {
    retStr += address?.addressStreet1 + " ";
  }

  if (isNonEmptyVariable(address?.addressStreet2)) {
    retStr += address?.addressStreet2 + " ";
  }

  if (isNonEmptyVariable(address?.addressApartmentNumber)) {
    retStr += address?.addressApartmentNumber + " ";
  }

  if (isNonEmptyVariable(address?.addressCity)) {
    retStr += address?.addressCity + " ";
  }

  if (isNonEmptyVariable(address?.addressState)) {
    retStr += address?.addressState + " ";
  }

  if (isNonEmptyVariable(address?.addressZip)) {
    retStr += address?.addressZip;
  }

  const finalStr = retStr?.split(" ").join(", ");

  return finalStr;
};

const base64ToImage = (base64String) => {
  try {
    // Remove the data URL prefix if present
    const base64Data = base64String.replace(/^data:image\/\w+;base64,/, "");

    // Convert Base64 to a Blob
    const byteCharacters = atob(base64Data);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "image/jpeg" });

    // Create an Object URL for the image
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error("Invalid Base64 string", error);
    return null;
  }
};

const base64ToBlob = (base64String) => {
  // Remove the data URL prefix if present
  const base64Data = base64String.replace(/^data:image\/\w+;base64,/, "");

  // Decode Base64
  const byteCharacters = atob(base64Data);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);
  return new Blob([byteArray], { type: "image/jpeg" });
};

const getFinalPath = (path) => {
  if (path?.includes("\\")) {
    const splitPath = path?.split("/");
    if (splitPath?.length === 4) {
      splitPath.shift();
      splitPath.shift();
    }

    return splitPath?.join("\\");
  }

  return path;
};

const checkGlobalClientParams = (
  paramName = "",
  paramContext = "",
  paramValue = ""
) => {
  if (!clientParamsLocal || clientParamsLocal.length === 0) return null;

  const filters = {};
  if (isNonEmptyVariable(paramName)) filters.paramName = paramName;
  if (isNonEmptyVariable(paramContext)) filters.paramContext = paramContext;
  if (isNonEmptyVariable(paramValue)) filters.paramValue = paramValue;

  const hasMatch = clientParamsLocal?.find((cp) =>
    Object.entries(filters).every(
      ([key, value]) => cp?.[key]?.toLowerCase() === value?.toLowerCase()
    )
  );

  return hasMatch || null;
};

// Remove trailing "_U" from the API field name and convert it to camelCase.
function convertColumnName(original) {
  const stripped = original.replace(/_U+$/, "").replace("#", "");
  const parts = stripped.split("_");
  return parts
    .map((word, index) => {
      word = word.toLowerCase();
      return index === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join("");
}

// Remove trailing "_U", replace underscores with spaces, and capitalize each word.
function convertLabel(original) {
  const stripped = original.replace(/_U+$/, "");
  const words = stripped.split("_");
  return words
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(" ");
}

// Convert API field definitions into our desired format for display.
const convertApiFields = (apiFields, tableName = "") => {
  let tb = tableName;

  return apiFields.map((field) => {
    const original = field.columnName;
    let refListName = "";
    const convertedColumnName = convertColumnName(original);
    let type = field.characterMaximumLength
      ? `${field.dataType}(${field.characterMaximumLength})`
      : field.dataType;

    const clientParam = checkGlobalClientParams(
      "",
      `${tb + ":" + original}`,
      ""
    );
    if (isNonEmptyVariable(clientParam)) {
      if (clientParam?.paramName === "OverrideSelect") {
        type = "bit";
        refListName = clientParam?.paramValue;
      }
    }
    const tableName = tb;
    const label = convertLabel(original);
    const required = field.isNullable === "NO";
    // Mark hidden fields: "BioExtraID" and "BioID" (case‑insensitive)
    const hidden = false;
    //   original.toLowerCase() === "bioextraid" ||
    //   original.toLowerCase() === "bioid";

    return {
      columnName: convertedColumnName,
      type,
      tableName,
      label,
      required,
      hidden,
      refListName,
    };
  });
};

const getLatestBookingsUtil = () => {
  return new Promise((resolve, reject) => {
    let url = API_ENDPOINTS.latestStaffBooking;
    if (isNonEmptyVariable(user) && user?.staffId === 1) {
      url = API_ENDPOINTS.latestBooking;
    }
    api
      .get(url)
      .then((response) => {
        if (response.status === 200 && response.data) {
          // dispatch(setBookings(response?.data));
          resolve(response?.data);
        }
      })
      .catch((error) => {
        console.error(
          "Request failed:",
          error.response ? error.response.data : error.message
        );
      });
  });
};

const getBookingsByNumberUtil = (bookingNumber) => {
  return new Promise((resolve, reject) => {
    let url = API_ENDPOINTS.bookings + "/bookingNumber/id/" + bookingNumber;
    if (isNonEmptyVariable(user) && user?.staffId === 1) {
      url = API_ENDPOINTS.latestBooking;
    }
    api
      .get(url)
      .then((response) => {
        if (response.status === 200 && response.data) {
          // dispatch(setBookings(response?.data));
          resolve(response?.data);
        }
      })
      .catch((error) => {
        console.error(
          "Request failed:",
          error.response ? error.response.data : error.message
        );
      });
  });
};

const imageToBase64 = async (url) => {
  try {
    const response = await fetch(url);
    const blob = await response.blob();
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result);
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Error converting image:", error);
  }
};

const extractPath = (url) => {
  try {
    // Convert backslashes to forward slashes
    url = url.replace(/\\/g, "/");

    // Create a URL object
    const parsedUrl = new URL(url);

    // Get the pathname and remove the leading slash
    return parsedUrl.pathname.startsWith("/")
      ? parsedUrl.pathname.substring(1)
      : parsedUrl.pathname;
  } catch (error) {
    console.error("Invalid URL:", error);
    return null;
  }
};
const getVisibleFields = (personalInfo, detailLevel, person) => {
  if (person) {
    return personalInfo?.[person] || [];
  }

  if (detailLevel.toLowerCase() === "low") {
    return personalInfo?.Low || [];
  }

  return Object.values(personalInfo).flat();
};

const getDayjsObject = (date, time) => {
  if (!isNonEmptyVariable(date)) return null; // Handle missing date case

  return isNonEmptyVariable(time) ? dayjs(`${date} ${time}`) : dayjs(date);
};

const formatDropDownOptions = (data) => {
  const formattedData =
    Array.isArray(data) && data.length > 0
      ? data.map((value, key) => ({ key, value }))
      : [{ key: 0, value: " " }];

  return formattedData;
};

const formatDropDownOptionsWithRefListId = (data, ValueAsString = false) => {
  const formattedData =
    Array.isArray(data) && data.length > 0
      ? data.map(({ refListItemGlobalID, defaultString }) => ({
          label: defaultString,
          value: ValueAsString ? defaultString : refListItemGlobalID,
        }))
      : [{ key: 0, value: " " }];
  return formattedData;
};

/**
 *
 * @param {Number} num
 */
export function generateNextSequence(num) {
  return num + 1;
}

const asyncFilter = async (array, asyncPredicate) => {
  const results = await Promise.all(array.map(asyncPredicate));
  return array.filter((_, index) => results[index]);
};

const hasCheckSecurity = (
  type,
  entityType,
  permission,
  identifierParam,
  subModuleName = null,
  schemaName = null,
  fieldName = null,
  startingPoint = null
) => {
  // Example JSON data
  const jsonData = securityRules;
  let securityFunctionality = jsonData?.securityRulesFunctionality;
  let identifier = identifierParam;
  let subModuleID = "";
  if (
    entityType == Entity_types.module ||
    entityType === Entity_types.subModule
  ) {
    identifier = modulesList?.find(
      (m) => m?.moduleName?.toLowerCase() === identifierParam?.toLowerCase()
    )?.moduleID;
    subModuleID = submoduleList?.find(
      (s) => s?.subModuleName?.toLowerCase() === subModuleName?.toLowerCase()
    )?.subModuleID;
  }

  let result = false;

  switch (type) {
    // Wrong Code
    case Security_Types.criteria:
      result = jsonData?.securityRulesCriteria?.some(
        (item) =>
          item?.entityType?.toLowerCase() === entityType?.toLowerCase() &&
          item?.allowSetting?.[permission] &&
          !item?.denySetting?.[permission] &&
          item.startingPoint === identifier &&
          item.staffGroupsID === subModuleID
      );
      break;

    // Correct Code
    case Security_Types.functionality:
      if (
        entityType == Entity_types.module ||
        entityType === Entity_types.subModule
      ) {
        result = jsonData?.securityRulesFunctionality?.some((item) => {
          if (
            item?.entityType?.toLowerCase() === entityType?.toLowerCase() &&
            item?.allowSetting?.[permission] === true &&
            item?.denySetting?.[permission] === false &&
            (item.moduleId === identifier ||
              item.arbitrary === identifier ||
              item.reportId === identifier ||
              item.tableViewId === identifier) &&
            (isNonEmptyVariable(subModuleID)
              ? item.subModuleId === subModuleID
              : true) &&
            item?.ruleActive
          ) {
            return true;
          }
        });

        return result;
      } else if (entityType == "field" || entityType == "Field") {
        return true;

        result = jsonData?.securityRulesFunctionality?.some((item) => {
          if (
            item?.entityType?.toLowerCase() === "field" &&
            item.schemaName == schemaName &&
            item.ruleActive &&
            (item.fieldName === fieldName || item.fieldName === "*") &&
            item.allowSetting[permission] &&
            !item.denySetting[permission] &&
            !item.startingPoint
          ) {
            return true;
          } else if (
            item?.entityType?.toLowerCase() === "field" &&
            item.schemaName == schemaName &&
            item.ruleActive &&
            (item.fieldName === fieldName || item.fieldName === "*") &&
            item.allowSetting[permission] &&
            !item.denySetting[permission] &&
            item.startingPoint == startingPoint
          ) {
            return true;
          }
        });

        return result;
      }
      break;

    case Security_Types.record:
      result = jsonData?.securityRulesRecords?.some(
        (item) =>
          item?.entityType?.toLowerCase() === entityType?.toLowerCase() &&
          item?.allowSetting?.[permission] &&
          !item?.denySetting?.[permission] &&
          item.startingPoint === identifier &&
          item.staffGroupsID === subModuleID
      );
      break;
    default:
      throw new Error("Invalid type specified");
  }

  // return result && isAllowed(allowSetting, denySetting);
  return result;
};

const getModuleNameByID = (moduleID = "", subModuleID = "") => {
  const returnArr = [];
  if (
    isNonEmptyVariable(modulesList) &&
    modulesList?.length &&
    isEmptyObject(moduleID)
  ) {
    const moduleName = modulesList?.find(
      (m) => m?.moduleID === moduleID
    )?.moduleName;
    returnArr.push(moduleName);
    if (
      isNonEmptyVariable(submoduleList) &&
      submoduleList?.length &&
      isEmptyObject(subModuleID)
    ) {
      const subModuleName = submoduleList?.find(
        (m) => m?.moduleID === moduleID && m?.subModuleID === subModuleID
      )?.subModuleName;
      returnArr.push(subModuleName);
    }

    return returnArr;
  } else {
    return "";
  }
};

const getReportNameByID = (reportID = "") => {
  const returnArr = [];
  if (
    isNonEmptyVariable(reportList) &&
    reportList?.length &&
    isEmptyObject(reportID)
  ) {
    const reportName = reportList?.find(
      (r) => r?.reportID === reportID
    )?.reportFileName;
    returnArr.push(reportName);

    return returnArr;
  } else {
    return "";
  }
};

const getTableViewsNameByID = (tableViewId = "") => {
  const returnArr = [];
  if (
    isNonEmptyVariable(tableViewsList) &&
    tableViewsList?.length &&
    isEmptyObject(tableViewId)
  ) {
    const tableViewsName = tableViewsList?.find(
      (t) => t?.tableViewID === tableViewId
    )?.tableViewName;
    returnArr.push(tableViewsName);

    return returnArr;
  } else {
    return "";
  }
};

/**
 * Reset all fields except the ones you want to preserve
 *
 * @param {Object} form - AntD form instance
 * @param {string[]} preserveFields - array of field names you DON'T want to reset
 */
const resetExcept = (form, preserveFields = []) => {
  const allFields = form.getFieldsValue();

  // Filter out fields that should NOT be preserved
  const fieldsToReset = Object.keys(allFields).filter(
    (name) => !preserveFields.includes(name)
  );

  form.resetFields(fieldsToReset);
};

const generateCurrentLocation = (inmateTrack, agency = "") => {
  if (!isNonEmptyVariable(inmateTrack)) return "";

  const builders = {
    "In Jail": () => {
      if (inmateTrack?.inJailType === "Cell") {
        const block = isNonEmptyVariable(inmateTrack?.block)
          ? inmateTrack.block
          : "";
        const cell = isNonEmptyVariable(inmateTrack?.cell)
          ? inmateTrack.cell
          : "";
        const bed = isNonEmptyVariable(inmateTrack?.bed) ? inmateTrack.bed : "";
        let Agency = isNonEmptyVariable(agency) ? `{${agency}}` : "";
        return `Cell ${block}${cell ? `:${cell}` : ""}${
          bed ? `:${bed}` : ""
        } ${Agency}`;
      }
      const holding = isNonEmptyVariable(inmateTrack?.holdingCell)
        ? inmateTrack.holdingCell
        : "";
      return `Holding (${holding})`;
    },

    Loan: () => {
      const destination = isNonEmptyVariable(inmateTrack?.loanDestination)
        ? inmateTrack.loanDestination
        : "";
      const type = isNonEmptyVariable(inmateTrack?.loanType)
        ? ` (${inmateTrack.loanType})`
        : "";
      return `Loan to ${destination}${type}`.trim();
    },

    "Perm Housing Change": () => {
      const dest = isNonEmptyVariable(inmateTrack?.transportDestination)
        ? inmateTrack.transportDestination
        : "";

      return `Perm Housing Change to ${dest}`.trim();
    },

    Transport: () => {
      const dest = isNonEmptyVariable(inmateTrack?.transportDestination)
        ? inmateTrack.transportDestination
        : "";
      return `Transport to ${dest}`.trim();
    },
  };

  return builders[inmateTrack.inmateLocation]?.() || "";
};

function isValidPassword(password) {
  // Regex explanation:
  // ^(?=.*[a-z])       -> at least one lowercase
  // (?=.*[A-Z])        -> at least one uppercase
  // (?=.*\d)           -> at least one number
  // (?=.*[^A-Za-z0-9]) -> at least one special character
  // .{12,}             -> at least 12 characters long
  // $
  const regex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z0-9]).{12,}$/;

  return regex.test(password);
}

function removeNullFromText(str) {
  return str
    .replace(/\b(null|undefined)\b/g, "")
    .replace(/\s+/g, " ")
    .trim();
}

function cleanObject(obj) {
  if (Array.isArray(obj)) {
    // If it's an array, recursively clean each item and filter out empty values
    return obj
      .map(cleanObject) // Recursively clean each element
      .filter(
        (value) =>
          value !== undefined &&
          value !== null &&
          value !== "" &&
          (Array.isArray(value) ? value.length > 0 : true) &&
          (typeof value === "object" ? Object.keys(value).length > 0 : true)
      );
  } else if (typeof obj === "object" && obj !== null) {
    // If it's an object, recursively clean its properties
    return Object.entries(obj).reduce((acc, [key, value]) => {
      const cleanedValue = cleanObject(value); // Recursively clean the value
      if (
        cleanedValue !== undefined &&
        cleanedValue !== null &&
        cleanedValue !== "" &&
        (typeof cleanedValue === "object"
          ? Object.keys(cleanedValue).length > 0
          : true)
      ) {
        acc[key] = cleanedValue; // Add only non-empty values
      }
      return acc;
    }, {});
  }
  // If it's a primitive value, return it as-is
  return obj;
}
const deepReplaceEmptyWithNull = (value) => {
  if (value === "") return null;

  if (Array.isArray(value)) {
    return value.map(v => deepReplaceEmptyWithNull(v));
  }

  if (value !== null && typeof value === "object") {
    return Object.fromEntries(
      Object.entries(value).map(([key, val]) => [
        key,
        deepReplaceEmptyWithNull(val)
      ])
    );
  }

  return value;
};

export {
  SetReflist,
  SetClientParam,
  SetSecurityRules,
  SetModulesList,
  isEmptyObject,
  objectToArray,
  toQueryString,
  isNonEmptyVariable,
  debounce,
  generateArray,
  checkField,
  checkFieldValidation,
  getSQLTypeToHTMLType,
  getOptionsFromRefList,
  getRefListNameByID,
  arrayToObject,
  checkRequiredField,
  findAgefromDOB,
  generateRules,
  filteredUndefinedData,
  getRefListItemsbyName,
  getFullAddress,
  base64ToImage,
  base64ToBlob,
  getFinalPath,
  checkGlobalClientParams,
  convertApiFields,
  getLatestBookingsUtil,
  getBookingsByNumberUtil,
  imageToBase64,
  extractPath,
  getVisibleFields,
  getDayjsObject,
  formatDropDownOptions,
  formatDropDownOptionsWithRefListId,
  asyncFilter,
  hasCheckSecurity,
  getModuleNameByID,
  getReportNameByID,
  getTableViewsNameByID,
  resetExcept,
  generateCurrentLocation,
  isValidPassword,
  removeNullFromText,
  cleanObject,
  deepReplaceEmptyWithNull,
};
